<template>
  <div class="reminders-component screen">
    <SheetVehicleFeatureHeader title="Reminders" :hasVehiclePicker="false" v-if="$isMobile" />
    <div class="header-band" v-else>
      <VehicleModalMenu @close="beforeClose()" />
      <span class="title">Reminders</span>
      <Tooltip class="ns-tooltip" @click.native="showTooltip" />
      <CloseButton variant="light" inline @click="beforeClose()" />
    </div>
    <SmoothReflow>
      <Alert />
      <div class="top">
        <div class="subheading">Vehicle licence renewal</div>
        <div class="buttons">
          <button class="btn btn-outline create-btn" @click="showModal('new-reminder', { type: 'Vehicle' })">Create</button>
        </div>
      </div>
      <div class="panel">
        <template v-if="vehicleLicenceReminders.length || loading">
          <PanelSpinner v-if="loading" />
          <div class="item container" v-for="item in vehicleLicenceReminders" :key="item.Id" v-else>
            <div class="row align-items-center text-center text-md-left">
              <div class="col-md-5 d-flex align-items-center justify-content-center justify-content-md-start my-3 my-md-0">
                <img src="~@/assets/images/avatar.svg" class="mr-2" width="40" height="40" alt />
                <span class="name">{{ item.Name }}</span>
              </div>
              <div class="col-md-4 mb-2 mb-md-0 d-flex d-md-block justify-content-evenly">
                <div class="date">
                  <img src="~@/assets/images/calendar.svg" width="20" height="20" alt />
                  <span>{{ getDate(item.DateSend) }}</span>
                </div>
                <div class="time">
                  <img src="~@/assets/images/clock.svg" width="20" height="20" alt />
                  <span>{{ getTime(item.DateSend) }}</span>
                </div>
              </div>
              <div class="actions col-md-3 mb-3 mb-md-0">
                <img src="~@/assets/images/edit.svg" class="button mr-md-1" width="25" height="25" alt @click="edit(item)" />
                <svg xmlns="http://www.w3.org/2000/svg" width="16.329" height="16.329" viewBox="0 0 16.329 16.329" class="delete-icon button" fill="currentColor" @click="deleteItem('Vehicle', item.Id)">
                  <path id="Path_8639" data-name="Path 8639" d="M-5614.277,60.126a.748.748,0,0,1-.53-.22.75.75,0,0,1,0-1.061l14.829-14.829a.75.75,0,0,1,1.061,0,.75.75,0,0,1,0,1.061l-14.829,14.829A.748.748,0,0,1-5614.277,60.126Z" transform="translate(5615.027 -43.797)" fill="#140047"/>
                  <path id="Path_8640" data-name="Path 8640" d="M-5599.448,60.126a.748.748,0,0,1-.53-.22l-14.829-14.829a.75.75,0,0,1,0-1.061.75.75,0,0,1,1.061,0l14.829,14.829a.75.75,0,0,1,0,1.061A.748.748,0,0,1-5599.448,60.126Z" transform="translate(5615.027 -43.797)" fill="#140047"/>
                </svg>
              </div>
            </div>
          </div>
        </template>
        <ErrorBox message="No reminders set. Create a reminder." v-else />
      </div>

      <div class="top">
        <div class="subheading">Driver's licence renewal</div>
        <div class="buttons">
          <button class="btn btn-outline create-btn" @click="showModal('new-reminder', { type: 'Driver' })">Create</button>
        </div>
      </div>
      <div class="panel">
        <template v-if="driversLicenceReminders.length || loading">
          <PanelSpinner v-if="loading" />
          <div class="item container" v-for="item in driversLicenceReminders" :key="item.Id" v-else>
            <div class="row align-items-center text-center text-md-left">
              <div class="col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mb-3 mb-md-0">
                <img src="~@/assets/images/avatar.svg" class="mr-2" width="40" height="40" alt />
                <div class="name">
                  <div>{{ item.DriverName }}</div>
                  <div>{{ item.DriverSurname }}</div>
                </div>
              </div>
              <div class="col-md-4 mb-3 mb-md-0 d-flex d-md-block justify-content-evenly">
                <div class="date">
                  <img src="~@/assets/images/calendar.svg" width="20" height="20" alt />
                  <span>{{ getDate(item.DateSend) }}</span>
                </div>
                <div class="time">
                  <img src="~@/assets/images/clock.svg" width="20" height="20" alt />
                  <span>{{ getTime(item.DateSend) }}</span>
                </div>
              </div>
              <div class="actions col-md-3 mb-3 mb-md-0">
                <img src="~@/assets/images/edit.svg" class="button mr-1" width="25" height="25" alt @click="edit(item)" />
                <svg xmlns="http://www.w3.org/2000/svg" width="16.329" height="16.329" viewBox="0 0 16.329 16.329" class="delete-icon button" fill="currentColor" @click="deleteItem('Vehicle', item.Id)">
                  <path id="Path_8639" data-name="Path 8639" d="M-5614.277,60.126a.748.748,0,0,1-.53-.22.75.75,0,0,1,0-1.061l14.829-14.829a.75.75,0,0,1,1.061,0,.75.75,0,0,1,0,1.061l-14.829,14.829A.748.748,0,0,1-5614.277,60.126Z" transform="translate(5615.027 -43.797)" fill="#140047"/>
                  <path id="Path_8640" data-name="Path 8640" d="M-5599.448,60.126a.748.748,0,0,1-.53-.22l-14.829-14.829a.75.75,0,0,1,0-1.061.75.75,0,0,1,1.061,0l14.829,14.829a.75.75,0,0,1,0,1.061A.748.748,0,0,1-5599.448,60.126Z" transform="translate(5615.027 -43.797)" fill="#140047"/>
                </svg>

              </div>
            </div>
          </div>
        </template>
        <ErrorBox message="No reminders set. Create a reminder." v-else />
      </div>
    </SmoothReflow>
  </div>
</template>

<style lang="scss" scoped>
@import "~@/assets/scss/variables.scss";

.reminders-component {
  .header-band {
    display: flex;
    align-items: center;
    background-color: $brand-color-1;
    height: 54px;
    padding: 0 30px;
    margin: -20px -30px -15px -30px;
    color: #fff;
    position: relative;
    font-size: 1.1875rem;

    /deep/ .menu-button .icon {
      fill: #fff;
    }

    .title {
      font-weight: 600;
      color: #fff;
      margin-left: 5px;
    }

    .ns-tooltip {
      margin-left: auto;
      margin-right: 5px;

      /deep/ .tooltip-target:not(.mobile) {
        background: #fff;
        color: $brand-color-1;
      }
    }

    /deep/ .close-button {
      margin-left: 0;
    }
  }

  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 2.125rem;
    margin-bottom: 10px;

    .subheading {
      font-size: 1rem;
    }

    .create-btn {
      min-width: 92px;
      font-size: 14px;
    }
  }

  .panel {
    background: $brand-color-4;
    padding: 20px;

    .item {
      background: #fff;
      position: relative;
      padding: 10px;
      margin-bottom: 15px;
      box-shadow: $drop-shadow-light;

      &:last-child {
        margin-bottom: 0;
      }

      .row > [class*="col-md"] {
        position: static;

        &:nth-child(1):after,
        &:nth-child(2):after {
          content: "";
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          height: 40px;
          border-right: 1px solid $brand-color-3;
        }

        &:nth-child(1):after {
          left: calc(41.666667% - 1px);
        }

        &:nth-child(2):after {
          left: calc(82% - 12px);
        }
      }

      .name {
        font-weight: 600;
      }

      .date {
        display: flex;
        align-items: center;
        margin-bottom: 5px;

        img {
          vertical-align: top;
          margin-right: 8px;
        }
      }

      .time {
        display: flex;
        align-items: center;

        img {
          vertical-align: top;
          margin-right: 8px;
        }
      }

      .actions {
        display: flex;
        align-items: center;
        justify-content: space-evenly;

        .delete-icon {
          fill: $brand-color-1;
        }

        .button {
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }
}

@media (max-width: $md-1) {
  .reminders-component {
    /deep/ .sheet-vehicle-feature-header-component {
      margin-bottom: -16px;
    }

    .panel {
      .item {
        .row {
          flex-wrap: wrap;
        }

        .row > [class*="col-md"] {
          &:nth-child(1):after,
          &:nth-child(2):after {
            display: none;
          }
        }

        // First column: avatar + name
        .row > [class*="col-md"]:nth-child(1) {
          flex: 1 1 auto !important;
          max-width: none !important;
          width: auto !important;
          display: flex;
          align-items: center;
          justify-content: flex-start !important;
          order: 1;
          margin-top: 0 !important;
          margin-bottom: 0 !important;
          padding-top: 3px;
          padding-bottom: 0;
          padding-left: 18px;
        }

        // Second column: date and time on own line
        .row > [class*="col-md"]:nth-child(2) {
          flex: 0 0 100% !important;
          max-width: 100% !important;
          width: 100% !important;
          display: flex;
          justify-content: center !important;
          align-items: center;
          margin-top: 10px;
          order: 3;

          .date {
            padding-right: 10px;
            margin-bottom: 0;
            border-right: 1px solid $brand-color-3;
          }

          .time {
            padding-left: 10px;
          }
        }

        // Third column: actions - inline with avatar + name
        .row > .actions {
          flex: 0 0 auto !important;
          max-width: none !important;
          width: auto !important;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          gap: 10px;
          order: 2;
          margin-top: 0 !important;
          margin-bottom: 0 !important;
          padding-top: 0;
          padding-bottom: 0;
          padding-right: 20px;
        }
      }
    }
  }
}
</style>

<script>
import { alertService, assetService, modalService, tooltipService } from "@/services";
import SheetVehicleFeatureHeader from "@/components/screens/SheetVehicleFeatureHeader";
import VehicleModalMenu from "@/components/screens/VehicleModalMenu";
import CloseButton from "@/components/CloseButton";
import Tooltip from "@/components/Tooltip";

export default {
  name: "Reminders",
  components: {
    VehicleModalMenu,
    CloseButton,
    SheetVehicleFeatureHeader,
    Tooltip,
  },
  data() {
    return {
      loading: true,
      vehicleLicenceReminders: [],
      driversLicenceReminders: [],
    };
  },
  created() {
    const startTime = Date.now();
    assetService
      .getVehicleReminders()
      .then((data) => {
        const timeElapsed = Date.now() - startTime;
        setTimeout(
          () => {
            data.forEach((reminder) => {
              switch (reminder.EditorMetadata) {
                case "Driver":
                  this.driversLicenceReminders.push(reminder);
                  break;
                case "Vehicle":
                  this.vehicleLicenceReminders.push(reminder);
                  break;
              }
            });
            this.loading = false;
          },
          timeElapsed < 500 ? 500 - timeElapsed : 0
        );
      })
      .catch((error) => {
        this.loading = false;
      });
  },
  methods: {
    beforeClose() {
      this.$emit("close");
    },
    showTooltip() {
      tooltipService.showTooltip("reminders");
    },
    getDate(dateTime) {
      return dateTime.split("T")[0];
    },
    getTime(dateTime) {
      const timeSplit = dateTime.split("T")[1].split(":");
      return timeSplit[0] + ":" + timeSplit[1];
    },
    edit(reminder) {
      this.showModal("new-reminder", { reminder: reminder });
    },
    deleteItem(type, id) {
      modalService.showDeleteDialog("Are you sure you want to delete this reminder?", () => {
        assetService.deleteVehicleReminder(id).then((result) => {
          if (result) {
            if (type == "Vehicle") {
              this.vehicleLicenceReminders = this.vehicleLicenceReminders.filter((e) => e.Id !== id);
            } else if (type == "Driver") {
              this.driversLicenceReminders = this.driversLicenceReminders.filter((e) => e.Id !== id);
            }
          } else {
            alertService.showErrorAlert();
          }
        });
      });
    },
    showModal(screenName, parameters) {
      modalService.showModal(this, screenName, parameters);
    },
  },
};
</script>